import { RootState } from '..';

export const currentUser = (state: RootState) => state.user.user;

export const currentRole = (state: RootState) => state.user.role;

export const isLoggedIn = (state: RootState) => state.user.isLoggedIn;

export const isImpersonating = (state: RootState) => state.user.isImpersonating;

export const error = (state: RootState) => state.user.error;

export const action = (state: RootState) => state.user.action;

export const status = (state: RootState) => state.user.status;
